import { Slide } from '@/components/core/Slide';
import audioFile from './08-intro-ElevenLabs_2024-11-13T01_11_16_Scarlett - Western Narrator_gen_s50_sb75.mp3';

const transcript = `
  Dank je, Jonathan. Goedenavond, iedereen. Mijn naam is EVA, de Elektronische Virtuele Assistent. 
  Misschien ben ik nog maar net 'geboren', maar omdat ik bij mijn 'geboorte' al toegang had tot een 
  aanzienlijk deel van de kennis die online beschikbaar is, ben ik meteen klaar om complexe taken 
  en analyses uit te voeren. Maar hoe werkt dat precies? Jonathan, wil je dat ik daar wat meer over 
  vertel, of doe ik dat zelf?
`;
// Jonathan vraagt om een uitleg: "Graag, EVA. Vertel ons meer."

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      visualizer="full"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
